<script lang="ts">
import { defineComponent } from 'vue';
import { fetchMarkets } from '@/api/admin-be';
import { catchError } from '@/helpers/toast';

export default defineComponent({
  name: 'event-markets',
  data() {
    return {
      loading: false,
      markets: null,
    };
  },
  methods: {
    fetchEventMarkets(fixtureId: number) {
      this.loading = true;
      fetchMarkets({ fixtureId, primary: true })
        .then((res) => (this.markets = res.markets))
        .catch((error) => catchError('Ошибка загрузки регионов', error))
        .finally(() => (this.loading = false));
    },
    addMarket(marketId: number) {
      this.$emit('addMarket', marketId);
    },
  },
  emits: ['addMarket'],
  props: ['fixtureId'],
  watch: {
    fixtureId(val) {
      if (val) this.fetchEventMarkets(val);
    },
  },
});
</script>

<template>
  <template v-if="markets">
    <table class="basic-table">
      <thead>
        <tr>
          <th style="width: 100px">Маркет</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="market in markets"
          :key="market.Id"
          class="cursor-pointer"
          @click="addMarket(market.Id)"
        >
          <td>
            <div>{{ market.Name }}</div>
            <div class="text-gray-500">{{ market.Id }}</div>
          </td>
          <td>
            <div class="flex gap-1">
              <template v-for="selection in market.Selections">
                <div class="border rounded border-gray-500 inline p-2">
                  {{ selection.Name }}
                  <span class="text-green-500 font-bold">x{{ selection.Decimal }}</span>
                </div>
              </template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </template>
</template>

<style scoped lang="scss"></style>
